// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__RpGoh","file":"styles_file__3o6-r"};